(function (window, document) {

  'use strict';



  function parseJson(id) {

    var el = document.getElementById(id);

    if (!el) return null;

    try {

      return JSON.parse(el.textContent || '{}');

    } catch (e) {

      return null;

    }

  }



  function money(cents, format) {

    var amount = (cents / 100).toFixed(2).replace('.', ',');

    var fmt = format || '€{{amount}}';

    if (fmt.indexOf('{{amount_no_decimals_with_comma_separator}}') !== -1) {

      return fmt.replace(

        '{{amount_no_decimals_with_comma_separator}}',

        String(Math.round(cents / 100))

      );

    }

    if (fmt.indexOf('{{amount_with_comma_separator}}') !== -1) {

      return fmt.replace('{{amount_with_comma_separator}}', amount);

    }

    return fmt.replace('{{amount}}', amount);

  }



  function leasingFromPrice(cents) {

    return Math.round((cents / 100 / 24) * 1.1);

  }



  function barcode8(value) {

    var barcode = String(value || '').trim();

    return /^\d{8}$/.test(barcode) ? barcode : '';

  }



  function isVariantPurchasable(variant) {

    return !!(variant && variant.available && variant.price > 0);

  }



  function norm(s) {

    return String(s || '')

      .toLowerCase()

      .normalize('NFD')

      .replace(/[\u0300-\u036f]/g, '');

  }



  function colorsMatch(a, b) {

    if (a == null || b == null) return a === b;

    if (window.AIOO_COLOR) return window.AIOO_COLOR.sameColor(a, b);

    return a === b;

  }



  /**

   * Canonical state.color for a raw variant option value (e.g. "Melna,Caurspīdīga").

   * Two-tone colors (hex2 set) MUST keep the full title, not just the primary

   * .label — otherwise colorsMatch()/sameColor() no longer round-trips back to

   * the raw variant value and every lookup that compares state.color against

   * v.options[colorIndex] silently fails (price/CTA show as unavailable even

   * though the variant is in stock). Mirrors uniqueCanonicalLabels()'s own

   * hex2 ? title : label rule — every call site that derives state.color from

   * a raw option value must go through this, not re-implement the ternary.

   */

  function canonicalColorState(raw) {

    if (!window.AIOO_COLOR) return raw;

    var resolved = window.AIOO_COLOR.resolve(raw);

    return resolved.hex2 ? resolved.title : resolved.label;

  }



  function findOptionIndex(options, names) {

    for (var i = 0; i < options.length; i++) {

      if (names.indexOf(options[i]) >= 0) return i;

    }

    return -1;

  }



  // Used watches keep case size and connectivity in ONE option value ("44mm LTE",

  // scripts/gms_used_watch_creator.py). Split it for display: {size: '44 mm', conn: 'LTE'}.

  function parseWatchSize(value) {

    var m = String(value || '').match(/^\s*(\d{2})\s*mm\b\s*(.*)$/i);

    return m ? { size: m[1] + ' mm', conn: m[2].trim() } : null;

  }



  function getUrlOptionFilters() {

    var out = {};

    try {

      var params = new URLSearchParams(window.location.search || '');

      params.forEach(function (val, key) {

        var m = String(key).match(/^filter\.v\.option\.(.+)$/i);

        if (!m) return;

        out[m[1].toLowerCase()] = val;

      });

    } catch (_e) {

      /* noop */

    }

    return out;

  }



  function optionFilterAliases(optionName) {

    var lc = String(optionName || '').toLowerCase();

    if (lc.indexOf('krās') >= 0 || lc.indexOf('kras') >= 0 || lc.indexOf('color') >= 0) {

      return ['krasa', 'krāsa', 'color', 'colour'];

    }

    if (lc.indexOf('atmiņ') >= 0 || lc.indexOf('storage') >= 0) {

      return ['atminas kapacitate', 'atmiņas kapacitāte', 'storage'];

    }

    if (

      lc.indexOf('klase') >= 0 ||

      lc.indexOf('stāvok') >= 0 ||

      lc.indexOf('stavok') >= 0 ||

      lc.indexOf('grade') >= 0 ||

      lc.indexOf('condition') >= 0

    ) {

      return ['klase', 'grade', 'condition', 'izvelies stavokli', 'izvēlies stāvokli'];

    }

    return [lc, lc.replace(/\s+/g, ' ')];

  }



  function readFilteredOptionValue(optionName) {

    var filters = getUrlOptionFilters();

    var aliases = optionFilterAliases(optionName);

    for (var i = 0; i < aliases.length; i++) {

      var key = norm(aliases[i]).replace(/\s+/g, ' ');

      if (filters[key]) return filters[key];

    }

    return null;

  }



  function uniqueValues(variants, index) {

    var seen = {};

    var out = [];

    variants.forEach(function (v) {

      var val = v.options[index];

      if (val == null || seen[val]) return;

      seen[val] = true;

      out.push(val);

    });

    return out;

  }



  function variantMatchesOptions(v, optionIndices, values, colorOptionIndex) {

    for (var i = 0; i < optionIndices.length; i++) {

      if (optionIndices[i] < 0) continue;

      var actual = v.options[optionIndices[i]];

      var expected = values[i];

      if (optionIndices[i] === colorOptionIndex) {

        if (!colorsMatch(actual, expected)) return false;

      } else if (actual !== expected) {

        return false;

      }

    }

    return true;

  }



  function findVariant(variants, optionIndices, values, colorOptionIndex) {

    return (

      variants.find(function (v) {

        if (!isVariantPurchasable(v)) return false;

        return variantMatchesOptions(v, optionIndices, values, colorOptionIndex);

      }) || null

    );

  }



  /** Match options without requiring stock — for price/CTA on sold-out variants. */

  function findVariantAny(variants, optionIndices, values, colorOptionIndex) {

    return (

      variants.find(function (v) {

        return variantMatchesOptions(v, optionIndices, values, colorOptionIndex);

      }) || null

    );

  }



  function findVariantPreservingOtherOptions(variants, colorIndex, color, baseVariant) {

    if (colorIndex < 0 || !color) return baseVariant || null;

    if (!baseVariant) {

      return findVariant(variants, [colorIndex], [color], colorIndex);

    }

    return (

      variants.find(function (v) {

        if (!isVariantPurchasable(v)) return false;

        if (!colorsMatch(v.options[colorIndex], color)) return false;

        for (var i = 0; i < v.options.length; i++) {

          if (i === colorIndex) continue;

          if (v.options[i] !== baseVariant.options[i]) return false;

        }

        return true;

      }) || null

    );

  }



  function findVariantPreservingOtherOptionsAny(variants, colorIndex, color, baseVariant) {

    if (colorIndex < 0 || !color) return baseVariant || null;

    if (!baseVariant) {

      return findVariantAny(variants, [colorIndex], [color], colorIndex);

    }

    return (

      variants.find(function (v) {

        if (!colorsMatch(v.options[colorIndex], color)) return false;

        for (var i = 0; i < v.options.length; i++) {

          if (i === colorIndex) continue;

          if (v.options[i] !== baseVariant.options[i]) return false;

        }

        return true;

      }) || null

    );

  }



  /** Cheapest variant for storage+grade (ignores stock) — for listing price on OOS grades. */

  function cheapestForStorageGrade(variants, indices, storage, grade) {

    var best = null;

    variants.forEach(function (v) {

      if (indices.storage >= 0 && v.options[indices.storage] !== storage) return;

      if (indices.grade >= 0 && v.options[indices.grade] !== grade) return;

      if (!best || v.price < best.price) best = v;

    });

    return best;

  }



  /** Cheapest variant for a storage tier (any grade/color). */

  function cheapestForStorage(variants, indices, storage) {

    var best = null;

    variants.forEach(function (v) {

      if (indices.storage >= 0 && v.options[indices.storage] !== storage) return;

      if (!best || v.price < best.price) best = v;

    });

    return best;

  }



  /** Price for a storage tier using current grade/color (matches main PDP price). */

  function getContextualStoragePrice(variants, indices, storage, state, colorIndex) {

    if (indices.storage < 0 || !storage) return null;



    var exact = findVariant(

      variants,

      [indices.storage, indices.grade, indices.color],

      [storage, state.grade, state.color],

      colorIndex

    );

    if (exact) return exact.price;



    if (indices.grade >= 0 && state.grade) {

      var byGrade = cheapestForStorageGrade(variants, indices, storage, state.grade);

      if (byGrade) return byGrade.price;

    }



    var bestAvail = null;

    variants.forEach(function (v) {

      if (!isVariantPurchasable(v)) return;

      if (indices.storage >= 0 && v.options[indices.storage] !== storage) return;

      if (!bestAvail || v.price < bestAvail.price) bestAvail = v;

    });

    if (bestAvail) return bestAvail.price;



    var fallback = cheapestForStorage(variants, indices, storage);

    return fallback ? fallback.price : null;

  }



  function hasCombo(variants, indices, storage, grade, color) {

    return !!findVariant(

      variants,

      [indices.storage, indices.grade, indices.color],

      [storage, grade, color],

      indices.color

    );

  }



  function PdpUsedPhone(root) {

    this.root = root;

    this.sectionId = root.getAttribute('data-section-id');

    this.config = parseJson('PdpV2Config-' + this.sectionId) || {};

    this.variants = this.config.variants || [];

    this.options = this.config.options || [];

    this.i18n = this.config.i18n || {};

    this.moneyFormat = this.config.moneyFormat || '€{{amount_with_comma_separator}}';

    this.isUsedPhone = !!this.config.isUsedPhone;

    this.isWatch = this.isUsedPhone && this.config.deviceKind === 'watch';

    this._atcInFlight = false;



    // Build battery lookup: Shopify variant legacy ID (string) → battery health % from GMS

    this.batteryMap = {};

    var _pdj = this.config.productDataJson;

    if (_pdj && Array.isArray(_pdj.variants)) {

      _pdj.variants.forEach(function (v) {

        var bat = v.attributes && v.attributes['25_Battery_status'];

        if (bat && v.id) { this.batteryMap[String(v.id)] = bat; }

      }, this);

    }



    this.indices = {

      storage: findOptionIndex(

        this.options,

        this.isWatch

          ? ['Izmērs', 'Size', 'Размер']

          : ['Atmiņas kapacitāte', 'Storage']

      ),

      grade: findOptionIndex(this.options, ['Klase', 'Grade', 'Condition', 'Izvēlies stāvokli']),

      color: findOptionIndex(this.options, ['Krāsa', 'Color']),

    };

    this.indices.accessoryModel = -1;

    if (!this.isUsedPhone && this.indices.color >= 0) {

      for (var i = 0; i < this.options.length; i++) {

        if (i === this.indices.color) continue;

        this.indices.accessoryModel = i;

        break;

      }

    }



    this.state = {

      storage: null,

      grade: null,

      color: null,

    };



    this.scope = this.getScope();

    var buybox = root.closest('.pdp-v2-buybox');



    this.els = {

      barcodeRow: buybox ? buybox.querySelector('[data-pdp-v2-barcode]') : null,

      barcodeVal: buybox ? buybox.querySelector('[data-pdp-v2-barcode-value]') : null,

      storageWrap: root.querySelector('[data-pdp-v2-storage]'),

      storageLabel: root.querySelector('[data-pdp-v2-storage-label]'),

      connSection: root.querySelector('[data-pdp-v2-conn-section]'),

      connWrap: root.querySelector('[data-pdp-v2-conn]'),

      connLabel: root.querySelector('[data-pdp-v2-conn-label]'),

      gradesWrap: root.querySelector('[data-pdp-v2-grades]'),

gradeNotice: root.querySelector('[data-pdp-v2-grade-notice]'),

      summary: root.querySelector('[data-pdp-v2-summary]'),

      gradeInfoBtn: root.querySelector('[data-pdp-v2-grade-info]'),

      gradeInfoBody: root.querySelector('[data-pdp-v2-grade-info-body]'),

      gradeInfoDialog: root.querySelector('[data-pdp-v2-grade-info-dialog]'),

      batterySection: root.querySelector('[data-pdp-v2-battery-section]'),

      batteryVal: root.querySelector('[data-pdp-v2-battery]'),

      colorsWrap: this.scope.querySelector('[data-pdp-v2-colors]'),

      colorLabel: this.scope.querySelector('[data-pdp-v2-color-label]'),

      price: root.querySelector('[data-pdp-v2-price]'),

      pricePanel: root.querySelector('[data-pdp-v2-price-panel]'),

      comparePrice: root.querySelector('[data-pdp-v2-compare-price]'),

      priceLabel: root.querySelector('[data-pdp-v2-price-label]'),

      leasing: root.querySelector('[data-pdp-v2-leasing]'),

      savings: root.querySelector('[data-pdp-v2-savings]'),

      lowStock: root.querySelector('[data-pdp-v2-low-stock]'),

      cta: root.querySelector('[data-pdp-v2-cta]'),

      ctaLabel: root.querySelector('[data-pdp-v2-cta-label]'),

      ctaIcon: root.querySelector('[data-pdp-v2-cta] .pdp-v2__btn-icon--cart'),

      altCta: root.querySelector('[data-pdp-v2-alt-cta]'),

      oosNote: root.querySelector('[data-pdp-v2-oos-note]'),

      homeDelivery: root.querySelector('[data-pdp-v2-home-delivery]'),

      variantSelect: document.getElementById('ProductSelect-' + this.sectionId),

      addBtn: document.getElementById('AddToCart-' + this.sectionId),

    };

    this.displayVariant = null;



    this.bind();

    this.bindVariantSelect();

    this.bindAccessoryModelSelect();

    this.initFromCurrentVariant();

    var self = this;

    window.setTimeout(function () {

      // Re-run gallery sync once Flickity has definitely finished initializing

      // (the first applyVariant() call above can race it). Must reuse the

      // same phone-aware lookup as applyVariant(), not the color-only

      // goToColorSlide — otherwise this delayed call re-introduces the R4

      // bug (docs/ERP_SHOPIFY_ARCHITECTURE_AUDIT.md §1.13) by snapping back

      // to the first slide of the color group a few hundred ms after load.

      if (self.isUsedPhone) {

        self.syncPhoneGallery(self.getCurrentVariant());

      } else if (self.state.color) {

        self.goToColorSlide(self.state.color);

      }

    }, 600);

  }



  PdpUsedPhone.prototype.getScope = function () {

    return (

      this.root.closest('product-form') ||

      this.root.closest('.productForm') ||

      this.root

    );

  };



  PdpUsedPhone.prototype.isAccessoryColorMode = function () {

    return (

      !this.isUsedPhone &&

      this.indices.color >= 0 &&

      this.indices.storage < 0 &&

      this.indices.grade < 0

    );

  };



  PdpUsedPhone.prototype.bind = function () {

    var self = this;

    var clickScope = this.scope || this.root;

    var ctaEl = this.root.querySelector('[data-pdp-v2-cta]');

    var formId = ctaEl && ctaEl.getAttribute('form');

    var productForm = formId && document.getElementById(formId);

    if (productForm && !productForm.dataset.pdpV2SubmitLock) {

      productForm.dataset.pdpV2SubmitLock = '1';

      productForm.addEventListener('submit', function (e) {

        e.preventDefault();

        e.stopPropagation();

      }, true);

    }

    clickScope.addEventListener('click', function (e) {

      var storageBtn = e.target.closest('[data-pdp-v2-storage-value]');

      if (storageBtn && !storageBtn.classList.contains('is-disabled')) {

        e.preventDefault();

        self.setStorage(storageBtn.getAttribute('data-pdp-v2-storage-value'));

        return;

      }

      var gradeBtn = e.target.closest('[data-pdp-v2-grade-value]');

      if (gradeBtn && !gradeBtn.classList.contains('is-disabled')) {

        e.preventDefault();

        self.setGrade(gradeBtn.getAttribute('data-pdp-v2-grade-value'));

        return;

      }

      var colorBtn = e.target.closest('[data-pdp-v2-color-value]');

      if (colorBtn && !colorBtn.disabled) {

        e.preventDefault();

        self.setColor(colorBtn.getAttribute('data-pdp-v2-color-value'));

        return;

      }

      if (e.target.closest('[data-pdp-v2-cta]')) {

        e.preventDefault();

        self.addToCartAndGoToCart();

        return;

      }

      if (e.target.closest('[data-pdp-v2-home-delivery]')) {

        e.preventDefault();

        self.applyVariant();

        var homeBtn = document.querySelector('[data-o2o-home-delivery]');

        if (homeBtn) homeBtn.click();

        else if (self.els.addBtn && !self.els.addBtn.disabled) self.els.addBtn.click();

        return;

      }

      if (e.target.closest('[data-pdp-v2-open-store]')) {

        e.preventDefault();

        var o2oRoot = self.root.querySelector('[data-o2o-root]');

        var openStore =

          o2oRoot &&

          (o2oRoot.querySelector('[data-o2o-availability-btn]') ||

            o2oRoot.querySelector('[data-o2o-primary]'));

        if (openStore) openStore.click();

        return;

      }

      if (e.target.closest('[data-pdp-v2-grade-info]')) {

        e.preventDefault();

        if (self.els.gradeInfoDialog && typeof self.els.gradeInfoDialog.showModal === 'function') {

          self.els.gradeInfoDialog.showModal();

        }

        return;

      }

      if (e.target.closest('[data-pdp-v2-grade-info-close]')) {

        e.preventDefault();

        if (self.els.gradeInfoDialog) self.els.gradeInfoDialog.close();

      }

    });

  };



  PdpUsedPhone.prototype.hasManagedOptions = function () {

    return (

      this.indices.storage >= 0 ||

      this.indices.grade >= 0 ||

      this.indices.color >= 0

    );

  };



  PdpUsedPhone.prototype.notifyO2OVariantChange = function (variant) {

    if (!variant || !variant.id) return;

    if (window.AIOO_O2O && typeof window.AIOO_O2O.onVariantChange === 'function') {

      window.AIOO_O2O.onVariantChange({ variant: variant });

    }

  };



  PdpUsedPhone.prototype.bindVariantSelect = function () {

    var self = this;

    if (!this.els.variantSelect) return;

    this.els.variantSelect.addEventListener('change', function () {

      var current = self.getCurrentVariant();

      if (current) self.notifyO2OVariantChange(current);

      if (self.hasManagedOptions()) {

        if (current) {

          if (self.indices.storage >= 0) {

            self.state.storage = current.options[self.indices.storage];

          }

          if (self.indices.grade >= 0) {

            self.state.grade = current.options[self.indices.grade];

          }

          if (self.indices.color >= 0) {

            var rawColor = current.options[self.indices.color];

            self.state.color = canonicalColorState(rawColor);

          }

        }

        self.renderAll();

      } else {

        self.applyVariant();

      }

    });

  };



  // The "Modelis" picker (pdp-accessory-model-filter.js) only updates its own

  // hidden native <select> — it never talks to this script. Without this,

  // picking a new model in the dialog left the color widget and the master

  // variant select frozen on whatever model/variant was active on page load,

  // so the visibly "selected" model and the variant actually added to cart

  // could silently diverge, including onto a sold-out variant

  // (wrong-model-in-cart bug, 2026-07-17 / 2026-07-23).

  //

  // Listening on the native <select>'s "change" event does NOT work here:

  // pickModel() re-dispatches it via jQuery(select).trigger('change'), and on

  // this page jQuery's trigger() never reaches native addEventListener

  // handlers (verified live — 0 native "change" listeners fire). The model

  // filter also broadcasts a plain document-level CustomEvent specifically

  // for cross-widget sync, dispatched with the native document.dispatchEvent,

  // so it isn't subject to the same jQuery gap.

  PdpUsedPhone.prototype.bindAccessoryModelSelect = function () {

    if (this.isUsedPhone || this.indices.accessoryModel < 0) return;

    var modelSelect =

      (this.scope && this.scope.querySelector('.pdp-accessory-model__native')) ||

      document.querySelector('.pdp-accessory-model__native');

    if (!modelSelect) return;

    var self = this;

    document.addEventListener('aioo:device:changed', function () {

      self.ensureColor();

      self.renderAll();

    });

  };



  PdpUsedPhone.prototype.syncSectionVisibility = function () {

    var self = this;

    if (!self.scope) return;

    self.scope.querySelectorAll('[data-pdp-v2-section]').forEach(function (section) {

      var key = section.getAttribute('data-pdp-v2-section');

      var visible = false;

      if (key === 'storage') {

        visible = self.indices.storage >= 0 && self.getStorageValues().length > 0;

      } else if (key === 'connectivity') {

        var watchRows = self.getWatchRows();

        visible =

          !!watchRows &&

          watchRows.some(function (r) {

            return r.conn;

          });

      } else if (key === 'grade') {

        visible = self.indices.grade >= 0 && self.getGradeValues().length > 0;

      } else if (key === 'color') {

        visible =

          self.indices.color >= 0 &&

          self.getColorValues().some(function (c) {

            return self.isColorAvailableAnywhere(c);

          });

      }

      section.hidden = !visible;

    });

  };



  PdpUsedPhone.prototype.applyUrlFiltersToState = function () {

    var self = this;

    if (this.indices.storage >= 0) {

      var storage = readFilteredOptionValue(this.options[this.indices.storage]);

      if (storage) this.state.storage = storage;

    }

    if (this.indices.grade >= 0) {

      var grade = readFilteredOptionValue(this.options[this.indices.grade]);

      if (grade) this.state.grade = grade;

    }

    if (this.indices.color >= 0) {

      var colorRaw = readFilteredOptionValue(this.options[this.indices.color]);

      if (colorRaw) {

        this.state.color = canonicalColorState(colorRaw);

      }

    }

    if (this.indices.storage >= 0 && !this.isStorageAvailable(this.state.storage)) {

      var storages = this.getStorageValues();

      this.state.storage =

        storages.find(function (s) {

          return self.isStorageAvailable(s);

        }) ||

        storages[0] ||

        null;

    }

    if (this.indices.grade >= 0) {

      var gradeList = this.getGradeValues();

      if (

        !this.state.grade ||

        gradeList.indexOf(this.state.grade) < 0 ||

        !this.isGradeAvailable(this.state.grade)

      ) {

        this.ensureGrade();

      }

    }

    this.ensureColor();

  };



  PdpUsedPhone.prototype.initFromCurrentVariant = function () {

    var hasUrlFilters = Object.keys(getUrlOptionFilters()).length > 0;

    if (hasUrlFilters) {

      this.applyUrlFiltersToState();

    } else {

      var current = this.getCurrentVariant();

      if (current) {

        if (this.indices.storage >= 0) this.state.storage = current.options[this.indices.storage];

        if (this.indices.grade >= 0) this.state.grade = current.options[this.indices.grade];

        if (this.indices.color >= 0) {

          var rawColor = current.options[this.indices.color];

          this.state.color = canonicalColorState(rawColor);

        }

      }

    }

    if (!this.state.storage && this.indices.storage >= 0) {

      var storages = this.getStorageValues();

      this.state.storage =

        storages.find(function (s) {

          return this.isStorageAvailable(s);

        }.bind(this)) ||

        storages[0] ||

        null;

    }

    this.ensureGrade();

    this.ensureColor();

    this.renderAll();

  };



  PdpUsedPhone.prototype.getCurrentVariant = function () {

    if (!this.els.variantSelect) {

      return this.displayVariant || this.variants.find(isVariantPurchasable) || this.variants[0] || null;

    }

    var id = parseInt(this.els.variantSelect.value, 10);

    if (!isNaN(id)) {

      var byValue = this.variants.find(function (v) { return v.id === id; });

      if (byValue) return byValue;

    }

    // Sold-out <option disabled> leaves .value empty in browsers — fall back

    // to the option at selectedIndex, then the last resolved display variant.

    var opt = this.els.variantSelect.options[this.els.variantSelect.selectedIndex];

    if (opt && opt.value) {

      var oid = parseInt(opt.value, 10);

      var byOpt = this.variants.find(function (v) { return v.id === oid; });

      if (byOpt) return byOpt;

    }

    return this.displayVariant || this.variants[0] || null;

  };



  PdpUsedPhone.prototype.getAccessoryModelValue = function () {

    if (this.isUsedPhone || this.indices.accessoryModel < 0) return null;

    // The "Modelis" native <select> reflects the customer's live pick in the

    // dialog; the master variant select (getCurrentVariant()) only catches up

    // once applyVariant() below has run. Reading the stale variant first

    // meant every availability/match check kept judging against the OLD

    // model until a color click happened to re-sync it (wrong-model-in-cart

    // bug, 2026-07-17 / 2026-07-23).

    var select =

      (this.scope && this.scope.querySelector('.pdp-accessory-model__native')) ||

      document.querySelector('.pdp-accessory-model__native');

    if (select && select.value) return select.value;

    var current = this.getCurrentVariant();

    if (current && current.options && current.options[this.indices.accessoryModel]) {

      return current.options[this.indices.accessoryModel];

    }

    return null;

  };



  PdpUsedPhone.prototype.ensureGrade = function () {

    if (this.indices.grade < 0) return;

    if (this.state.grade && this.isGradeAvailableAnywhere(this.state.grade)) {

      if (this.isGradeAvailable(this.state.grade)) return;

    }

    var grades = this.getGradeValues();

    this.state.grade =

      grades.find(function (g) {

        return this.isGradeAvailable(g);

      }.bind(this)) ||

      grades[0] ||

      null;

  };



  function fillTemplate(str, map) {

    return String(str).replace(/\{(\w+)\}/g, function (m, key) {

      return key in map ? map[key] : m;

    });

  }



  PdpUsedPhone.prototype.hideGradeNotice = function () {

    var el = this.els.gradeNotice;

    if (!el) return;

    window.clearTimeout(this._gradeNoticeTimer);

    el.hidden = true;

    el.textContent = '';

  };



  // Tell the customer when picking one option moved another one (a grade that

  // only exists in another storage/color, or a color that was out of stock in

  // the new combination) instead of changing the selection silently.

  PdpUsedPhone.prototype.announceSelectionChange = function (before, template, extra) {

    var el = this.els.gradeNotice;

    if (!el) return;

    var parts = [];

    var moved = [];

    // A storage tap already shows its own result, so it never lists storage.

    if (

      this.indices.storage >= 0 &&

      before.storage !== this.state.storage &&

      !(extra && extra.skipStorage)

    ) {

      parts.push(this.state.storage);

      moved.push(this.els.storageWrap);

    }

    if (extra && extra.includeGrade && this.indices.grade >= 0 && before.grade !== this.state.grade) {

      parts.push(this.state.grade + ' (' + this.gradeLabel(this.state.grade) + ')');

      moved.push(this.els.gradesWrap);

    }

    // A color tap already shows its own result, so it never lists the color.

    if (

      this.indices.color >= 0 &&

      this.state.color &&

      !colorsMatch(before.color, this.state.color) &&

      !(extra && extra.skipColor)

    ) {

      parts.push(this.state.color);

      moved.push(this.els.colorsWrap);

    }

    if (!parts.length) {

      this.hideGradeNotice();

      return;

    }

    this.flashMoved(moved);

    window.clearTimeout(this._gradeNoticeTimer);

    el.textContent = fillTemplate(template, {

      grade: this.state.grade || '',

      color: this.state.color || '',

      options: parts.join(' · '),

    });

    el.hidden = false;

    this._gradeNoticeTimer = window.setTimeout(this.hideGradeNotice.bind(this), 9000);

  };

  // Briefly ring the controls that were moved for the shopper, so the change is noticed and not only read about.

  PdpUsedPhone.prototype.flashMoved = function (wraps) {

    var selector = '.pdp-v2__pill.is-selected, .pdp-v2__grade.is-selected, .pdp-v2__color.is-selected';

    wraps.forEach(function (wrap) {

      var node = wrap && wrap.querySelector(selector);

      if (!node) return;

      node.classList.remove('is-flash');

      void node.offsetWidth;

      node.classList.add('is-flash');

      window.setTimeout(function () {

        node.classList.remove('is-flash');

      }, 1600);

    });

  };



  PdpUsedPhone.prototype.setStorage = function (value) {

    var before = { storage: this.state.storage, grade: this.state.grade, color: this.state.color };

    this.state.storage = value;

    this.ensureGrade();

    this.ensureColor();

    this.renderAll();

    this.announceSelectionChange(

      before,

      this.i18n.optionsAdjusted || 'Izvēle pielāgota pieejamībai: {options}.',

      { includeGrade: true, skipStorage: true }

    );

  };



  PdpUsedPhone.prototype.setGrade = function (value) {

    if (!this.isGradeAvailableAnywhere(value)) return;

    var before = { storage: this.state.storage, grade: this.state.grade, color: this.state.color };

    if (!this.isGradeAvailableWithColor(value)) this.ensureComboForGrade(value);

    this.state.grade = value;

    this.ensureColor();

    this.renderAll();

    this.announceSelectionChange(

      before,

      this.i18n.gradeSwitched || 'Klase {grade} ir pieejama šādā konfigurācijā: {options}.'

    );

  };



  PdpUsedPhone.prototype.setColor = function (value) {

    if (this.isUsedPhone) {

      if (!this.isColorAvailable(value)) {

        this.switchToColorCombo(value);

        return;

      }

      this.hideGradeNotice();

    } else {

      // Accessories: allow browsing OOS colors for price/gallery; only reject

      // values that are not real option values on this product.

      var exists = this.getColorValues().some(function (c) {

        return colorsMatch(c, value);

      });

      if (!exists) return;

    }

    this.state.color = canonicalColorState(value);

    this.renderAll();

  };



  PdpUsedPhone.prototype.ensureColor = function () {

    if (this.indices.color < 0) return;

    if (this.isColorAvailable(this.state.color)) return;

    var inStock = this.getColorValues().find(function (c) {

      return this.isColorAvailable(c);

    }.bind(this));

    if (inStock) {

      this.state.color = inStock;

      return;

    }

    // All colors sold out — keep a display color so price and OOS CTA resolve.

    var stillValid =

      this.state.color &&

      this.getColorValues().some(function (c) {

        return colorsMatch(c, this.state.color);

      }.bind(this));

    if (!stillValid) {

      this.state.color = this.getColorValues()[0] || null;

    }

  };



  PdpUsedPhone.prototype.getColorValues = function () {

    if (this.indices.color < 0) return [];

    var rawColors = uniqueValues(this.variants, this.indices.color);

    var self = this;

    // uniqueCanonicalLabels collapses e.g. "Rozā pērļu ar dizainu" down to the

    // plain label "Rozā" for dedup/display — keep a raw-value lookup per key so

    // renderColors() can re-resolve the ORIGINAL string and still pick up

    // hex2/isPattern instead of losing them on the already-canonicalized label.

    this._colorRawByKey = {};

    if (window.AIOO_COLOR) {

      rawColors.forEach(function (raw) {

        var resolved = window.AIOO_COLOR.resolve(raw);

        var id = window.AIOO_COLOR.swatchId

          ? window.AIOO_COLOR.swatchId(resolved)

          : resolved.key;

        if (id && !(id in self._colorRawByKey)) {

          self._colorRawByKey[id] = raw;

        }

      });

    }

    var colors = window.AIOO_COLOR

      ? window.AIOO_COLOR.uniqueCanonicalLabels(rawColors)

      : rawColors.slice();

    colors.sort(function (a, b) {

      var aCombo = self.isColorAvailable(a) ? 0 : 1;

      var bCombo = self.isColorAvailable(b) ? 0 : 1;

      if (aCombo !== bCombo) return aCombo - bCombo;

      var aAny = self.isColorAvailableAnywhere(a) ? 0 : 1;

      var bAny = self.isColorAvailableAnywhere(b) ? 0 : 1;

      if (aAny !== bAny) return aAny - bAny;

      return String(a).localeCompare(String(b), 'lv');

    });

    return colors;

  };



  PdpUsedPhone.prototype.getOptionValuesFromConfig = function (optionIndex) {

    var list = this.config.optionsWithValues;

    if (optionIndex < 0 || !list || !list.length) return null;

    var name = this.options[optionIndex];

    if (!name) return null;

    for (var i = 0; i < list.length; i++) {

      var row = list[i];

      if (!row || !row.name) continue;

      if (row.name === name) {

        var vals = row.values;

        return Array.isArray(vals) && vals.length ? vals : null;

      }

    }

    return null;

  };



  PdpUsedPhone.prototype.getStorageValues = function () {

    if (this.indices.storage < 0) return [];

    var fromCfg = this.getOptionValuesFromConfig(this.indices.storage);

    var values =

      fromCfg && fromCfg.length ? fromCfg : uniqueValues(this.variants, this.indices.storage);

    return values.filter(function (storage) {

      return this.isStorageAvailable(storage);

    }, this);

  };



  PdpUsedPhone.prototype.getGradeValues = function () {

    var order = ['AA', 'A', 'B', 'C'];

    var values;

    if (this.indices.grade >= 0) {

      var fromCfg = this.getOptionValuesFromConfig(this.indices.grade);

      if (fromCfg && fromCfg.length) values = fromCfg.slice();

      else values = uniqueValues(this.variants, this.indices.grade);

    } else {

      values = [];

    }

    var seen = {};

    var merged = [];

    values.forEach(function (v) {

      if (v == null || seen[v]) return;

      seen[v] = true;

      merged.push(v);

    });

    merged.sort(function (a, b) {

      var ia = order.indexOf(a);

      var ib = order.indexOf(b);

      var sa = ia >= 0 ? ia : 999;

      var sb = ib >= 0 ? ib : 999;

      if (sa !== sb) return sa - sb;

      return String(a).localeCompare(String(b));

    });

    return merged.filter(function (grade) {

      return this.isGradeAvailableAnywhere(grade);

    }, this);

  };



  PdpUsedPhone.prototype.isGradeAvailableAnywhere = function (grade) {

    if (this.indices.grade < 0 || grade == null) return false;

    return this.variants.some(function (v) {

      return isVariantPurchasable(v) && v.options[this.indices.grade] === grade;

    }, this);

  };



  PdpUsedPhone.prototype.isStorageAvailable = function (storage) {

    if (this.indices.storage < 0) return false;

    return this.variants.some(function (v) {

      return isVariantPurchasable(v) && v.options[this.indices.storage] === storage;

    }, this);

  };



  PdpUsedPhone.prototype.isGradeAvailable = function (grade) {

    var self = this;

    return this.variants.some(function (v) {

      if (!isVariantPurchasable(v)) return false;

      if (self.indices.storage >= 0 && v.options[self.indices.storage] !== self.state.storage) return false;

      if (self.indices.grade >= 0 && v.options[self.indices.grade] !== grade) return false;

      return true;

    });

  };



  // Whether ANY variant of this product (any model, any storage/grade) has

  // stock in this color — deliberately ignores the currently selected model.

  // This gates whether the swatch is shown at all: a color stays visible as

  // long as some variation of the product carries it, and only disappears

  // once every variant in that color is sold out everywhere. Availability

  // for the CURRENTLY selected model is a separate, narrower question — see

  // isColorAvailable(), which drives the muted/crossed-out state.

  PdpUsedPhone.prototype.isColorAvailableAnywhere = function (color) {

    var self = this;

    return this.variants.some(function (v) {

      if (!isVariantPurchasable(v)) return false;

      if (self.indices.color >= 0 && !colorsMatch(v.options[self.indices.color], color)) return false;

      return true;

    });

  };



  // Switch storage/color to a combo where the given color is available (prefers current storage).

  PdpUsedPhone.prototype.ensureStorageGradeForColor = function (color) {

    if (this.isColorAvailable(color)) return;

    var self = this;

    var candidates = this.variants.filter(function (v) {

      if (!isVariantPurchasable(v)) return false;

      if (self.indices.color >= 0 && !colorsMatch(v.options[self.indices.color], color)) return false;

      return true;

    });

    var match =

      (self.indices.storage >= 0 &&

        candidates.find(function (v) {

          return v.options[self.indices.storage] === self.state.storage;

        })) ||

      candidates[0];

    if (!match) return;

    if (self.indices.storage >= 0) self.state.storage = match.options[self.indices.storage];

    if (self.indices.grade >= 0) self.state.grade = match.options[self.indices.grade];

  };



  // In-stock variants that carry the given grade, in any storage/color.

  PdpUsedPhone.prototype.gradeCandidates = function (grade) {

    var self = this;

    return this.variants.filter(function (v) {

      if (!isVariantPurchasable(v)) return false;

      if (self.indices.grade >= 0 && v.options[self.indices.grade] !== grade) return false;

      return true;

    });

  };



  function cheapestOf(list) {

    var best = null;

    list.forEach(function (v) {

      if (!best || v.price < best.price) best = v;

    });

    return best;

  }



  // The variant a click on this grade lands on: the cheapest in-stock one,

  // preferring the current storage. Using the same pick for the button price

  // and for the switch keeps "what you see is what you get".

  PdpUsedPhone.prototype.pickComboForGrade = function (grade) {

    var self = this;

    var candidates = this.gradeCandidates(grade);

    if (!candidates.length) return null;

    var pool = candidates;

    if (self.indices.storage >= 0) {

      var sameStorage = candidates.filter(function (v) {

        return v.options[self.indices.storage] === self.state.storage;

      });

      if (sameStorage.length) pool = sameStorage;

    }

    return cheapestOf(pool);

  };



  // Grade in stock for the CURRENT storage AND color. isGradeAvailable only looks

  // at storage, so a card could advertise a price for a color the shopper has

  // not picked.

  PdpUsedPhone.prototype.isGradeAvailableWithColor = function (grade) {

    return !!this.cheapestForCurrentColor(grade);

  };

  // Cheapest purchasable variant of this grade in the selected storage and color.

  PdpUsedPhone.prototype.cheapestForCurrentColor = function (grade) {

    var self = this;

    return cheapestOf(

      this.variants.filter(function (v) {

        if (!isVariantPurchasable(v)) return false;

        if (self.indices.storage >= 0 && v.options[self.indices.storage] !== self.state.storage) return false;

        if (self.indices.grade >= 0 && v.options[self.indices.grade] !== grade) return false;

        if (self.indices.color >= 0 && self.state.color && !colorsMatch(v.options[self.indices.color], self.state.color)) {

          return false;

        }

        return true;

      })

    );

  };

  // The variant a tap on an out-of-selection color lands on: keep the storage if

  // the color exists there, then the grade, then take the cheapest. The same pick

  // feeds the swatch tooltip and the switch, so what is promised is what happens.

  PdpUsedPhone.prototype.pickComboForColor = function (color) {

    var self = this;

    var pool = this.variants.filter(function (v) {

      return isVariantPurchasable(v) && (self.indices.color < 0 || colorsMatch(v.options[self.indices.color], color));

    });

    if (!pool.length) return null;

    function narrow(list, idx, val) {

      if (idx < 0 || !val) return list;

      var kept = list.filter(function (v) {

        return v.options[idx] === val;

      });

      return kept.length ? kept : list;

    }

    pool = narrow(pool, this.indices.storage, this.state.storage);

    pool = narrow(pool, this.indices.grade, this.state.grade);

    return cheapestOf(pool);

  };

  PdpUsedPhone.prototype.switchToColorCombo = function (color) {

    var match = this.pickComboForColor(color);

    if (!match) return;

    var before = { storage: this.state.storage, grade: this.state.grade, color: this.state.color };

    if (this.indices.storage >= 0) this.state.storage = match.options[this.indices.storage];

    if (this.indices.grade >= 0) this.state.grade = match.options[this.indices.grade];

    this.state.color = canonicalColorState(color);

    this.renderAll();

    this.announceSelectionChange(

      before,

      this.i18n.colorSwitched || 'Krāsa {color} ir pieejama šādā konfigurācijā: {options}.',

      { includeGrade: true, skipColor: true }

    );

  };

  // Tooltip / screen-reader text for a swatch that is outside the current selection.

  PdpUsedPhone.prototype.colorElsewhereHint = function (color, label) {

    var match = this.pickComboForColor(color);

    if (!match) return '';

    var parts = [];

    if (this.indices.storage >= 0 && match.options[this.indices.storage] !== this.state.storage) {

      parts.push(match.options[this.indices.storage]);

    }

    if (this.indices.grade >= 0 && match.options[this.indices.grade] !== this.state.grade) {

      var g = match.options[this.indices.grade];

      parts.push(g + ' (' + this.gradeLabel(g) + ')');

    }

    if (!parts.length) return '';

    return fillTemplate(this.i18n.colorElsewhere || '{color}: {options}', {

      color: label || color,

      options: parts.join(' · '),

    });

  };

  // Plain recap of the picked configuration, shown above the price.

  PdpUsedPhone.prototype.renderSummary = function () {

    var box = this.els.summary;

    if (!box) return;

    var val = box.querySelector('[data-pdp-v2-summary-value]');

    var parts = [];

    if (this.indices.storage >= 0 && this.state.storage) parts.push(this.state.storage);

    if (this.indices.grade >= 0 && this.state.grade) {

      parts.push(this.state.grade + ' (' + this.gradeLabel(this.state.grade) + ')');

    }

    if (this.indices.color >= 0 && this.state.color) parts.push(this.state.color);

    if (!val || !parts.length) {

      box.hidden = true;

      return;

    }

    val.textContent = parts.join(' · ');

    box.hidden = false;

  };

  // Switch storage/color to a combo where the given grade is available.

  PdpUsedPhone.prototype.ensureComboForGrade = function (grade) {

    if (this.isGradeAvailableWithColor(grade)) return;

    var self = this;

    var match = this.pickComboForGrade(grade);

    if (!match) return;

    if (self.indices.storage >= 0) self.state.storage = match.options[self.indices.storage];

    if (self.indices.color >= 0) {

      var rawColor = match.options[self.indices.color];

      self.state.color = canonicalColorState(rawColor);

    }

  };



  PdpUsedPhone.prototype.isColorAvailable = function (color) {

    var self = this;

    // See isColorAvailableAnywhere: anchor on the picker's selected model, not

    // the (possibly stale) master variant select.

    var accessoryModel = self.isAccessoryColorMode() ? self.getAccessoryModelValue() : null;

    return this.variants.some(function (v) {

      if (!isVariantPurchasable(v)) return false;

      if (self.indices.storage >= 0 && v.options[self.indices.storage] !== self.state.storage) {

        return false;

      }

      if (self.indices.grade >= 0 && v.options[self.indices.grade] !== self.state.grade) {

        return false;

      }

      if (accessoryModel != null && v.options[self.indices.accessoryModel] !== accessoryModel) {

        return false;

      }

      if (self.indices.color >= 0 && !colorsMatch(v.options[self.indices.color], color)) {

        return false;

      }

      return true;

    });

  };



  PdpUsedPhone.prototype.renderAll = function () {

    this.renderStorage();

    this.renderGrades();

    this.renderGradeDesc();

    this.renderColors();

    this.renderSummary();

    this.syncSectionVisibility();

    this.applyVariant();

  };



  PdpUsedPhone.prototype.getSelectedStoragePrice = function () {

    if (!this.state.storage) return null;

    return getContextualStoragePrice(

      this.variants,

      this.indices,

      this.state.storage,

      this.state,

      this.indices.color

    );

  };



  PdpUsedPhone.prototype.formatStorageLabel = function (value) {

    if (value === this.state.storage) return value;

    var optionPrice = getContextualStoragePrice(

      this.variants,

      this.indices,

      value,

      this.state,

      this.indices.color

    );

    var selectedPrice = this.getSelectedStoragePrice();

    if (optionPrice == null || selectedPrice == null) return value;

    var diff = optionPrice - selectedPrice;

    if (diff === 0) return value;

    var delta = money(Math.abs(diff), this.moneyFormat);

    return diff > 0 ? value + ' +' + delta : value + ' -' + delta;

  };



  PdpUsedPhone.prototype.getFirstMissingSelection = function () {

    if (!this.hasManagedOptions()) return null;

    if (this.indices.storage >= 0 && !this.state.storage) return 'storage';

    if (this.indices.grade >= 0 && !this.state.grade) return 'grade';

    if (this.indices.color >= 0 && !this.state.color) return 'color';

    var variant = findVariant(

      this.variants,

      [this.indices.storage, this.indices.grade, this.indices.color],

      [this.state.storage, this.state.grade, this.state.color],

      this.indices.color

    );

    if (!variant) {

      // Sold-out selection is not "missing" — only nudge when another in-stock

      // option exists for that axis (otherwise applyVariant shows Izpārdots).

      if (

        this.indices.grade >= 0 &&

        this.state.grade &&

        !this.isGradeAvailable(this.state.grade) &&

        this.getGradeValues().some(function (g) {

          return this.isGradeAvailableAnywhere(g);

        }, this)

      ) {

        return 'grade';

      }

      if (

        this.indices.color >= 0 &&

        this.state.color &&

        !this.isColorAvailable(this.state.color) &&

        this.getColorValues().some(function (c) {

          return this.isColorAvailable(c);

        }, this)

      ) {

        return 'color';

      }

      if (

        this.indices.storage >= 0 &&

        this.state.storage &&

        !this.isStorageAvailable(this.state.storage) &&

        this.getStorageValues().some(function (s) {

          return this.isStorageAvailable(s);

        }, this)

      ) {

        return 'storage';

      }

    }

    return null;

  };



  PdpUsedPhone.prototype.highlightMissingSelection = function (key) {

    var section =

      (this.scope && this.scope.querySelector('[data-pdp-v2-section="' + key + '"]')) ||

      this.root.querySelector('[data-pdp-v2-section="' + key + '"]');

    if (!section) return;

    section.classList.remove('is-highlight-pulse');

    void section.offsetWidth;

    section.classList.add('is-highlight-pulse');

    section.scrollIntoView({ behavior: 'smooth', block: 'center' });

    window.setTimeout(function () {

      section.classList.remove('is-highlight-pulse');

    }, 2200);

  };



  // Rows for the two-pill-row watch picker: one entry per buyable option value, or null when a

  // value does not look like "<NN>mm [connectivity]" (the single storage-style row is used then).

  PdpUsedPhone.prototype.getWatchRows = function () {

    if (!this.isWatch || !this.els.connWrap) return null;

    var rows = [];

    var values = this.getStorageValues();

    for (var i = 0; i < values.length; i++) {

      var parsed = parseWatchSize(values[i]);

      if (!parsed) return null;

      rows.push({ value: values[i], size: parsed.size, conn: parsed.conn });

    }

    return rows.length ? rows : null;

  };



  function watchPill(label, targetValue, selected) {

    var btn = document.createElement('button');

    btn.type = 'button';

    btn.className = 'pdp-v2__pill' + (selected ? ' is-selected' : '');

    btn.setAttribute('data-pdp-v2-storage-value', targetValue);

    btn.setAttribute('aria-pressed', selected ? 'true' : 'false');

    btn.textContent = label;

    return btn;

  }



  // Case size row + connectivity row. Every pill still carries one real option value, so the

  // normal setStorage() path handles the click. A pill whose partner does not exist for the other

  // row (no 44 mm GPS) switches the other row to the nearest value instead of dead-ending.

  PdpUsedPhone.prototype.renderWatchRows = function (rows) {

    var cur = parseWatchSize(this.state.storage) || { size: rows[0].size, conn: rows[0].conn };

    var sizes = [];

    var conns = [];

    rows.forEach(function (r) {

      if (sizes.indexOf(r.size) < 0) sizes.push(r.size);

      if (r.conn && conns.indexOf(r.conn) < 0) conns.push(r.conn);

    });

    var sizeWrap = this.els.storageWrap;

    var connWrap = this.els.connWrap;

    sizeWrap.innerHTML = '';

    connWrap.innerHTML = '';

    sizes.forEach(function (size) {

      var target =

        rows.filter(function (r) { return r.size === size && r.conn === cur.conn; })[0] ||

        rows.filter(function (r) { return r.size === size; })[0];

      sizeWrap.appendChild(watchPill(size, target.value, size === cur.size));

    });

    conns.forEach(function (conn) {

      var target =

        rows.filter(function (r) { return r.conn === conn && r.size === cur.size; })[0] ||

        rows.filter(function (r) { return r.conn === conn; })[0];

      connWrap.appendChild(watchPill(conn, target.value, conn === cur.conn));

    });

    if (this.els.connSection) this.els.connSection.hidden = conns.length === 0;

    if (this.els.storageLabel) {

      var sizeBase = this.i18n.watchSizeLabel || 'Korpusa izmērs';

      this.els.storageLabel.textContent = sizeBase + ': ' + cur.size;

    }

    if (this.els.connLabel && cur.conn) {

      var connBase = this.i18n.watchConnectivityLabel || 'Savienojamība';

      this.els.connLabel.textContent = connBase + ': ' + cur.conn;

    }

  };



  PdpUsedPhone.prototype.renderStorage = function () {

    var wrap = this.els.storageWrap;

    if (!wrap || this.indices.storage < 0) return;

    var watchRows = this.getWatchRows();

    if (watchRows) {

      this.renderWatchRows(watchRows);

      return;

    }

    if (this.els.connSection) this.els.connSection.hidden = true;

    wrap.innerHTML = '';

    this.getStorageValues().forEach(function (value) {

      var btn = document.createElement('button');

      btn.type = 'button';

      btn.className =

        'pdp-v2__pill' + (value === this.state.storage ? ' is-selected' : '');

      btn.setAttribute('data-pdp-v2-storage-value', value);

      btn.textContent = this.formatStorageLabel(value);

      wrap.appendChild(btn);

    }, this);

    this.updateStorageLabel();

  };



  PdpUsedPhone.prototype.updateStorageLabel = function () {

    if (!this.els.storageLabel) return;

    var base = this.i18n.storageLabel || 'Atmiņas kapacitāte';

    this.els.storageLabel.textContent = this.state.storage

      ? base + ': ' + this.state.storage

      : base;

  };



  PdpUsedPhone.prototype.renderGrades = function () {

    var wrap = this.els.gradesWrap;

    if (!wrap || this.indices.grade < 0) return;

    wrap.innerHTML = '';

    this.getGradeValues().forEach(function (grade) {

      var available = this.isGradeAvailableWithColor(grade);

      var availableAnywhere = this.isGradeAvailableAnywhere(grade);

      // In stock, just not in the selected storage/color: this is a real, buyable

      // grade, so it must not read as "Nav pieejams" (clicking it switches the

      // configuration and says so).

      var elsewhere = !available && availableAnywhere;

      var sample = available ? this.cheapestForCurrentColor(grade) : this.pickComboForGrade(grade);

      var hint = '';

      var priceText = sample ? money(sample.price, this.moneyFormat) : '-';

      if (elsewhere && sample) {

        var candidates = this.gradeCandidates(grade);

        var sameStorage =

          this.indices.storage >= 0

            ? candidates.filter(function (v) {

                return v.options[this.indices.storage] === this.state.storage;

              }, this)

            : candidates;

        var pool = sameStorage.length ? sameStorage : candidates;

        if (sameStorage.length && this.indices.color >= 0) {

          // The grade exists in this storage, just not in the picked color.

          var colorsHere = uniqueValues(pool, this.indices.color);

          hint =

            colorsHere.length === 1

              ? fillTemplate(this.i18n.gradeOnlyColor || 'Tikai {color}', { color: colorsHere[0] })

              : this.i18n.gradeOtherColor || 'Citā krāsā';

        } else {

          var storages = uniqueValues(pool, this.indices.storage);

          hint =

            storages.length === 1

              ? fillTemplate(this.i18n.gradeOnlyStorage || 'Tikai {storage}', { storage: storages[0] })

              : this.i18n.gradeOtherStorage || 'Citā atmiņā';

        }

        var priced = pool.some(function (v) {

          return v.price !== sample.price;

        });

        if (priced) {

          priceText = fillTemplate(this.i18n.gradeFrom || 'no {price}', { price: priceText });

        }

      }

      var selected = grade === this.state.grade;

      var btn = document.createElement('button');

      btn.type = 'button';

      btn.className =

        'pdp-v2__grade' +

        (selected ? ' is-selected' : '') +

        (elsewhere ? ' is-elsewhere' : '') +

        (availableAnywhere ? '' : ' is-disabled');

      btn.setAttribute('data-pdp-v2-grade-value', grade);

      btn.setAttribute(

        'aria-label',

        this.gradeLabel(grade) + (hint ? ' (' + hint + ')' : '') + ', ' + priceText

      );

      if (!availableAnywhere) {

        btn.disabled = true;

        btn.setAttribute('aria-disabled', 'true');

      }

      btn.innerHTML =

        '<div class="pdp-v2__grade-head">' +

        '<span class="pdp-v2__grade-letter">' +

        grade +

        '</span>' +

        (selected ? '<span class="pdp-v2__grade-check" aria-hidden="true">✓</span>' : '') +

        (hint ? '<span class="pdp-v2__grade-hint">' + hint + '</span>' : '') +

        '</div>' +

        '<span class="pdp-v2__grade-name">' +

        this.gradeLabel(grade) +

        '</span>' +

        '<span class="pdp-v2__grade-price">' +

        priceText +

        '</span>';

      wrap.appendChild(btn);

    }, this);

  };



  PdpUsedPhone.prototype.renderGradeDesc = function () {

    var infoBtn = this.els.gradeInfoBtn;

    var body = this.els.gradeInfoBody;

    if (!infoBtn || !body) return;

    var key = this.state.grade;

    var desc = this.i18n.gradeDescriptions && this.i18n.gradeDescriptions[key];

    if (desc && key) {

      // Locale strings already include the grade name (e.g. "Labs: …").

      body.textContent = desc;

      infoBtn.hidden = false;

    } else {

      body.textContent = '';

      infoBtn.hidden = true;

      if (this.els.gradeInfoDialog && this.els.gradeInfoDialog.open) {

        this.els.gradeInfoDialog.close();

      }

    }

  };



  PdpUsedPhone.prototype.renderColors = function () {

    var wrap = this.els.colorsWrap;

    if (!wrap || this.indices.color < 0) return;

    wrap.innerHTML = '';

    var unavailableLabel = this.i18n.gradeUnavailable || 'Nav pieejams';

    var colors = this.getColorValues();

    colors.forEach(function (color) {

      var availableAnywhere = this.isColorAvailableAnywhere(color);

      // Phones: hide colors sold out on every variant. Accessories: keep OOS

      // swatches so a fully sold-out product still shows color + price.

      if (this.isUsedPhone && !availableAnywhere) return;

      var availableNow = this.isColorAvailable(color);

      var selected =

        this.state.color &&

        (color === this.state.color || colorsMatch(color, this.state.color));

      var resolvedPreview = window.AIOO_COLOR ? window.AIOO_COLOR.resolve(color) : null;

      var rawLookupId = resolvedPreview && window.AIOO_COLOR.swatchId

        ? window.AIOO_COLOR.swatchId(resolvedPreview)

        : (resolvedPreview && resolvedPreview.key);

      var resolveSource =

        (this._colorRawByKey && rawLookupId && this._colorRawByKey[rawLookupId]) ||

        color;

      var resolved = window.AIOO_COLOR

        ? window.AIOO_COLOR.resolve(resolveSource)

        : { hex: '#d1d5db', hex2: null, hex3: null, isPattern: false };

      var btn = document.createElement('button');

      btn.type = 'button';

      btn.className =

        'pdp-v2__color aioo-swatch' +

        (selected ? ' is-selected' : '') +

        (availableNow ? '' : this.isUsedPhone ? ' is-elsewhere' : ' is-muted') +

        (resolved.hex2 ? ' has-split' : '') +

        (resolved.hex3 ? ' has-triple' : '') +

        (resolved.isPattern ? ' is-pattern' : '');

      btn.style.backgroundColor = resolved.hex;

      btn.style.setProperty('--aioo-sw-c1', resolved.hex);

      btn.style.setProperty('--aioo-sw-c2', resolved.hex2 || resolved.hex);

      if (resolved.hex3) btn.style.setProperty('--aioo-sw-c3', resolved.hex3);

      btn.setAttribute('data-pdp-v2-color-value', color);

      var elsewhereHint =

        !availableNow && this.isUsedPhone ? this.colorElsewhereHint(color, resolved.title || color) : '';

      btn.setAttribute(

        'aria-label',

        elsewhereHint || (resolved.title || color) + (availableNow ? '' : ' (' + unavailableLabel + ')')

      );

      if (elsewhereHint) {

        btn.title = elsewhereHint;

        btn.innerHTML = '<span class="pdp-v2__color-slash" aria-hidden="true"></span>';

      }

      // Muted = sold out for the currently selected model. On phones, disable

      // (another in-stock color exists). On accessories with only OOS colors,

      // keep the selected swatch interactive for display consistency.

      if (!availableNow && !this.isUsedPhone && availableAnywhere) {

        btn.disabled = true;

        btn.setAttribute('aria-disabled', 'true');

      }

      if (selected) {

        btn.innerHTML = '<span class="pdp-v2__color-check" aria-hidden="true">✓</span>';

      }

      wrap.appendChild(btn);

    }, this);

    if (this.els.colorLabel) {

      this.els.colorLabel.textContent =

        (this.i18n.colorLabel || 'Krāsa') + ': ' + (this.state.color || '');

    }

  };



  PdpUsedPhone.prototype.getVariantFeaturedImage = function (variantId) {

    var product = parseJson('ProductJson-' + this.sectionId);

    if (!product || !product.variants) return null;

    for (var i = 0; i < product.variants.length; i++) {

      if (product.variants[i].id === variantId) {

        return product.variants[i].featured_image || null;

      }

    }

    return null;

  };



  function imageSrcKey(src) {

    return String(src || '')

      .split('?')[0]

      .replace(/^https?:/i, '');

  }



  PdpUsedPhone.prototype.updateAccessoryHeroImage = function (variant) {

    if (this.isUsedPhone || !variant) return;

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell || shell.getAttribute('data-pdp-accessory-gallery') !== 'single') return;



    var featured = this.getVariantFeaturedImage(variant.id);

    if (!featured || !featured.src) return;



    var img =

      shell.querySelector('.product-featured-img') ||

      shell.querySelector('.featImg' + this.sectionId) ||

      shell.querySelector('.pdp-v2-gallery img');

    if (!img) return;



    var base = String(featured.src).split('?')[0];

    var hi = base.indexOf('cdn.shopify.com') !== -1 ? base + '?width=1200' : base;

    img.setAttribute('data-src', hi);

    img.src = hi;

    img.classList.add('lazyloaded');

    img.classList.remove('lazyload');



    var counter = document.querySelector('[data-pdp-v2-gallery-counter]');

    if (counter) counter.textContent = '1 / 1';

    hydrateGalleryImages(shell);

  };



  PdpUsedPhone.prototype.syncAccessoryGallery = function (variant) {

    if (this.isUsedPhone || !variant) return;



    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell) return;



    if (shell.getAttribute('data-pdp-accessory-gallery') === 'single') {

      this.updateAccessoryHeroImage(variant);

      return;

    }



    var slider = shell.querySelector('.primgSlider');

    if (!slider || !window.jQuery) return;



    var targetMediaId = null;

    var vg = this.config.visualGallery;

    if (vg && vg.variant_map) {

      targetMediaId =

        vg.variant_map[String(variant.id)] || vg.variant_map[variant.id] || null;

    }



    var idx = -1;

    var cells = slider.querySelectorAll('.pr_photo, .pswip, .pr_photo.pswipe');

    if (targetMediaId != null) {

      for (var i = 0; i < cells.length; i++) {

        if (String(cells[i].id) === String(targetMediaId)) {

          idx = i;

          break;

        }

      }

    }



    if (idx < 0) {

      var featured = this.getVariantFeaturedImage(variant.id);

      if (!featured || !featured.src) return;

      var targetKey = imageSrcKey(featured.src);

      for (var j = 0; j < cells.length; j++) {

        var img = cells[j].querySelector('img');

        if (!img) continue;

        var imgKey = imageSrcKey(img.getAttribute('data-src') || img.currentSrc || img.src);

        if (imgKey === targetKey) {

          idx = j;

          break;

        }

      }

    }



    if (idx < 0) return;



    var $slider = window.jQuery(slider);

    if ($slider.data('flickity')) {

      $slider.flickity('select', idx, false, true);

      hydrateGalleryImages(slider);

    }

  };



  // Gallery by colour (product tag pdp-gallery-by-color, rendered by sections/product-template.liquid):

  // the slider holds the photo of the selected colour plus the SHARED photos (media bound to no variant).

  // Photos of the other colours wait in the slider element as hidden `.pdp-gallery-off` nodes that are not

  // Flickity cells (cellSelector skips them); they are swapped in and out here when the colour changes.

  function isGalleryByColor(shell) {

    return !!shell && shell.getAttribute('data-pdp-gallery-by-color') === 'true';

  }



  // A slide key written by Liquid's colour normaliser is hyphenated ("gaisi-zila") while

  // AIOO_COLOR.resolve() returns it with spaces ("gaisi zila"): two-word colours never matched

  // and the gallery stayed on the previous colour's photo.

  function colorKeysMatch(cellKey, targetKey) {

    if (!cellKey || !targetKey) return false;

    return cellKey === targetKey || galleryColorSlug(cellKey) === galleryColorSlug(targetKey);

  }



  // Liquid's colour normaliser writes keys with hyphens ("tumsi-zila"), AIOO_COLOR.resolve() with

  // spaces ("tumsi zila"): compare them as slugs.

  function galleryColorSlug(value) {

    return norm(value).trim().replace(/[\s_-]+/g, '-');

  }



  // Scope of media bound to no variant: JSON of the product metafield custom.pdp_gallery_colors, printed by

  // the section as <script data-pdp-gallery-scopes>: {"<media id>": {"only": [...]} | {"except": [...], "locale": [...]}}.

  function galleryLocale(shell) {

    if (!shell) return 'lv';

    if (!shell._pdpGalleryLocale) {

      var raw = shell.getAttribute('data-pdp-gallery-locale') || document.documentElement.lang || 'lv';

      shell._pdpGalleryLocale = String(raw).split('-')[0].toLowerCase();

    }

    return shell._pdpGalleryLocale;

  }



  function galleryLocaleAllowed(rule) {

    if (!rule || !rule.locale || !rule.locale.length) return true;

    return rule.locale.indexOf(galleryLocale(document.querySelector('.pdp-v2-gallery'))) >= 0;

  }



  function galleryScopes(shell) {

    if (shell._pdpGalleryScopes) return shell._pdpGalleryScopes;

    var scopes = {};

    var el = shell.querySelector('script[data-pdp-gallery-scopes]');

    if (el) {

      try {

        scopes = JSON.parse(el.textContent) || {};

      } catch (_e) {

        scopes = {};

      }

    }

    shell._pdpGalleryScopes = scopes;

    return scopes;

  }



  function galleryScopeSlugs(list) {

    return (Array.isArray(list) ? list : []).map(galleryColorSlug);

  }



  // null: the cell is shared (shown for every colour); true / false: a colour-scoped cell (the photo of

  // one colour, or a shared photo limited by `only` / `except`) that is / is not for this colour.

  function galleryCellVisibleFor(cell, slug, scopes) {

    var bound = galleryColorSlug(cell.getAttribute('data-pdp-color'));

    if (bound) return bound === slug;

    var rule = scopes[galleryCellMediaId(cell)];

    if (!rule) return null;

    if (!galleryLocaleAllowed(rule)) return false;

    if (rule.only) return galleryScopeSlugs(rule.only).indexOf(slug) >= 0;

    if (rule.except) return galleryScopeSlugs(rule.except).indexOf(slug) < 0;

    return null;

  }



  // Media id -> position in the product's media list, read from the thumbnail strip (its nodes never move).

  function galleryMediaOrder() {

    var order = {};

    document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumbs_item .pr_thumb').forEach(function (thumb, i) {

      order[String(thumb.id).replace(/^img/, '')] = i;

    });

    return order;

  }



  function galleryCellMediaId(cell) {

    return String(cell.id || cell.getAttribute('data-media-id') || '');

  }



  // Highlight the thumb of the slide on screen (matched by media id: the strip keeps the media order,

  // which can differ from the order of the slides).

  function syncGalleryActiveThumb(flkty, index) {

    var cell = flkty.cells[index];

    var id = cell ? galleryCellMediaId(cell.element) : '';

    document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumbs_item').forEach(function (item) {

      var thumb = item.querySelector('.pr_thumb');

      var on = !!thumb && id !== '' && String(thumb.id).replace(/^img/, '') === id;

      item.classList.toggle('active-thumb', on);

      if (thumb) thumb.classList.toggle('activeSlide', on);

    });

  }



  // The photos of the colours that are not selected are display:none and loading=lazy, so the browser

  // never fetches them; warm the cache once so that a colour switch shows its photo at once.

  function preloadGalleryColors(slider) {

    slider.querySelectorAll('.pr_photo.pdp-gallery-off img[data-src]').forEach(function (img) {

      var warm = new Image();

      warm.src = img.getAttribute('data-src');

    });

  }



  // Mirror the slider onto the thumbnail strip and the counter: thumbs of hidden photos go away, the

  // numbering follows the slides that are on screen.

  function syncGalleryByColorUi(flkty) {

    var order = {};

    flkty.cells.forEach(function (cell, i) {

      cell.element.setAttribute('data-slide', String(i));

      order[galleryCellMediaId(cell.element)] = i;

    });

    document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumbs_item').forEach(function (item) {

      var thumb = item.querySelector('.pr_thumb');

      var id = thumb ? String(thumb.id).replace(/^img/, '') : '';

      var pos = Object.prototype.hasOwnProperty.call(order, id) ? order[id] : -1;

      item.classList.toggle('pdp-gallery-off', pos < 0);

      if (pos >= 0) item.setAttribute('data-slide', String(pos));

    });

    var index = flkty.selectedIndex || 0;

    syncGalleryActiveThumb(flkty, index);

    var counter = document.querySelector('[data-pdp-v2-gallery-counter]');

    if (counter) counter.textContent = index + 1 + ' / ' + (flkty.cells.length || 1);

  }



  // Returns true when the gallery is in by-colour mode (handled here, even if only to do nothing).

  PdpUsedPhone.prototype.syncGalleryByColor = function (color) {

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!isGalleryByColor(shell)) return false;

    var slider = shell.querySelector('.primgSlider');

    if (!slider || !window.jQuery) return true;

    var $slider = window.jQuery(slider);

    var flkty = $slider.data('flickity');

    // Flickity not up yet: the server already rendered the right colour, the delayed call in the

    // constructor runs again once it is.

    if (!flkty) return true;



    var key = galleryColorSlug(window.AIOO_COLOR ? window.AIOO_COLOR.resolve(color).key : color);

    // Colour-scoped cells: the photo of each colour and the shared photos limited to some colours.

    // The cells that are not scoped (shared by every colour) are never touched.

    var scopes = galleryScopes(shell);

    var scoped = [];

    var wanted = [];

    var hasPhoto = false;

    Array.prototype.forEach.call(slider.querySelectorAll('.pr_photo'), function (cell) {

      var visible = galleryCellVisibleFor(cell, key, scopes);

      if (visible === null) return;

      scoped.push(cell);

      if (!visible) return;

      wanted.push(cell);

      if (cell.getAttribute('data-pdp-color')) hasPhoto = true;

    });

    if (!hasPhoto) return true; // no photo for this colour: keep what is on screen



    var order = galleryMediaOrder();

    wanted.sort(function (a, b) {

      return (order[galleryCellMediaId(a)] || 0) - (order[galleryCellMediaId(b)] || 0);

    });

    var shown = scoped.filter(function (cell) { return !cell.classList.contains('pdp-gallery-off'); });

    var unchanged = shown.length === wanted.length && wanted.every(function (cell) { return shown.indexOf(cell) >= 0; });

    if (!unchanged) {

      if (shown.length) {

        $slider.flickity('remove', shown); // detaches the nodes; park them back, hidden

        shown.forEach(function (cell) {

          cell.classList.add('pdp-gallery-off');

          slider.appendChild(cell);

        });

      }

      // the class goes first: Flickity filters what it adopts with cellSelector

      wanted.forEach(function (cell) { cell.classList.remove('pdp-gallery-off'); });

      $slider.flickity('prepend', wanted);

    }



    var elements = flkty.cells.map(function (cell) { return cell.element; });

    $slider.flickity('select', Math.max(elements.indexOf(wanted[0]), 0), false, true);

    hydrateGalleryImages(slider);

    syncGalleryByColorUi(flkty);

    return true;

  };



  PdpUsedPhone.prototype.goToColorSlide = function (color) {

    if (!color) return;

    if (this.syncGalleryByColor(color)) return;

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell) return;

    var slider = shell.querySelector('.primgSlider');

    if (!slider || !window.jQuery) return;

    var $slider = window.jQuery(slider);

    var flkty = $slider.data('flickity');

    if (!flkty) return;



    var targetKey = window.AIOO_COLOR

      ? window.AIOO_COLOR.resolve(color).key

      : norm(color);

    var cells = slider.querySelectorAll('[data-pdp-color]');

    var idx = -1;

    for (var i = 0; i < cells.length; i++) {

      var cellKey = cells[i].getAttribute('data-pdp-color') || '';

      if (colorKeysMatch(cellKey, targetKey)) {

        idx = i;

        break;

      }

    }

    if (idx >= 0) {

      $slider.flickity('select', idx, false, true);

      hydrateGalleryImages(slider);

    }

  };



  // Image/pswipe cells carry the Shopify media id as `id="{{ media.id }}"`,

  // but non-image cells (video/external_video/model/generic — see the

  // gallery loop in sections/product-template.liquid) carry it as

  // `data-media-id="{{ media.id }}"` instead, sometimes prefixed

  // (`data-media-id="{{ section.id }}-{{ media.id }}"` for the model type).

  // Check both so the exact-variant match doesn't silently miss non-image

  // media (Bugbot R4 follow-up).

  function cellMatchesMediaId(cell, mediaId) {

    if (mediaId == null) return false;

    var idStr = String(mediaId);

    if (String(cell.id) === idStr) return true;

    var dataMediaId = cell.getAttribute('data-media-id');

    if (dataMediaId == null) return false;

    if (dataMediaId === idStr) return true;

    var suffix = '-' + idStr;

    return dataMediaId.length > suffix.length && dataMediaId.slice(-suffix.length) === suffix;

  }



  // Slide index lookup by exact media id, scanning the same cell set/order

  // Flickity uses internally (DOM order), so the returned index is safe to

  // pass to flickity('select', idx).

  function findSlideIndexByMediaId(slider, mediaId) {

    if (mediaId == null) return -1;

    var cells = slider.querySelectorAll('.pr_photo, .pswip, .pr_photo.pswipe');

    for (var i = 0; i < cells.length; i++) {

      if (cellMatchesMediaId(cells[i], mediaId)) return i;

    }

    return -1;

  }



  // Slide index lookup by canonical color, over the FULL cell list (not the

  // `[data-pdp-color]`-only subset goToColorSlide scans) so the index always

  // matches Flickity's own numbering.

  function findSlideIndexByColor(slider, color) {

    if (!color) return -1;

    var targetKey = window.AIOO_COLOR ? window.AIOO_COLOR.resolve(color).key : norm(color);

    var cells = slider.querySelectorAll('.pr_photo, .pswip, .pr_photo.pswipe');

    for (var i = 0; i < cells.length; i++) {

      var cellKey = cells[i].getAttribute('data-pdp-color') || '';

      if (colorKeysMatch(cellKey, targetKey)) return i;

    }

    return -1;

  }



  // Phones (used + new) must show the SELECTED VARIANT's own media when

  // possible. Fallback chain, in order:

  //   1. exact media of the selected variant (variant.mediaId, from Liquid

  //      variant.featured_media || variant.image — see

  //      snippets/pdp-used-phone-v2.liquid);

  //   2. any media tagged with the variant's canonical color

  //      (data-pdp-color, set in sections/product-template.liquid);

  //   3. the product's default/featured media.

  // Illustrative-photo badge is always visible (rendered in Liquid).

  PdpUsedPhone.prototype.syncPhoneGallery = function (variant) {

    if (!this.isUsedPhone) return;

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell) return;

    var slider = shell.querySelector('.primgSlider');

    if (!slider || !window.jQuery) return;

    var $slider = window.jQuery(slider);

    var flkty = $slider.data('flickity');

    if (!flkty) return;



    var mediaId = variant ? variant.mediaId : null;

    var idx = findSlideIndexByMediaId(slider, mediaId);

    var isExact = idx >= 0;



    if (idx < 0 && this.state.color && this.indices.color >= 0) {

      var colorIdx = this.indices.color;

      var wantColor = this.state.color;

      var donor = this.variants.filter(function (v) {

        return v.mediaId && colorsMatch(v.options[colorIdx], wantColor);

      })[0];

      if (donor) idx = findSlideIndexByMediaId(slider, donor.mediaId);

    }



    if (idx < 0) {

      idx = findSlideIndexByColor(slider, this.state.color);

    }



    if (idx < 0 && this.config.productFeaturedMediaId != null) {

      idx = findSlideIndexByMediaId(slider, this.config.productFeaturedMediaId);

    }



    if (idx >= 0) {

      $slider.flickity('select', idx, false, true);

      hydrateGalleryImages(slider);

    }



    this.updateRepresentativePhotoBadge(idx >= 0 && !isExact);

  };



  // Badge is always rendered in Liquid for every PDP; do not toggle/clear it.

  PdpUsedPhone.prototype.updateRepresentativePhotoBadge = function () {};



  // Re-evaluate the badge against whatever slide is now on screen. Needed

  // because syncPhoneGallery() only runs on variant change: manual swipe,

  // prev/next buttons and thumbnail clicks (wired in initGallery() below)

  // move the slide without going through it, which used to leave a stale

  // badge state (Bugbot R4 follow-up).

  PdpUsedPhone.prototype.syncRepresentativeBadgeForSlideIndex = function (index) {

    if (!this.isUsedPhone) return;

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell) return;

    var slider = shell.querySelector('.primgSlider');

    if (!slider) return;

    var cells = slider.querySelectorAll('.pr_photo, .pswip, .pr_photo.pswipe');

    var cell = cells[index];

    if (!cell) return;

    var variant = this.getCurrentVariant();

    var mediaId = variant ? variant.mediaId : null;

    this.updateRepresentativePhotoBadge(!cellMatchesMediaId(cell, mediaId));

  };



  PdpUsedPhone.prototype.applyVariant = function () {

    var variant = null;

    if (this.hasManagedOptions()) {

      if (this.isAccessoryColorMode()) {

        var selectedModel = this.getAccessoryModelValue();

        if (selectedModel && this.indices.accessoryModel >= 0) {

          variant = findVariant(

            this.variants,

            [this.indices.accessoryModel, this.indices.color],

            [selectedModel, this.state.color],

            this.indices.color

          );

          if (!variant) {

            // The requested color is sold out for the selected model — fall back to

            // any purchasable color for that SAME model rather than silently

            // reverting to whichever model the cart happened to be on before

            // (wrong-model-in-cart bug, 2026-07-17 / 2026-07-23).

            variant = this.variants.find(function (v) {

              return isVariantPurchasable(v) && v.options[this.indices.accessoryModel] === selectedModel;

            }, this) || null;

            if (variant && this.indices.color >= 0) {

              var matchedColorRaw = variant.options[this.indices.color];

              this.state.color = canonicalColorState(matchedColorRaw);

            }

          }

          // Fully sold out for this model — still resolve for price / OOS CTA.

          if (!variant) {

            variant = findVariantAny(

              this.variants,

              [this.indices.accessoryModel, this.indices.color],

              [selectedModel, this.state.color],

              this.indices.color

            );

            if (!variant) {

              variant =

                this.variants.find(function (v) {

                  return v.options[this.indices.accessoryModel] === selectedModel;

                }, this) || null;

            }

          }

        }

        if (!variant) {

          variant = findVariantPreservingOtherOptions(

            this.variants,

            this.indices.color,

            this.state.color,

            this.getCurrentVariant()

          );

        }

        if (!variant) {

          variant = findVariant(this.variants, [this.indices.color], [this.state.color], this.indices.color);

        }

        if (!variant) {

          variant = findVariantPreservingOtherOptionsAny(

            this.variants,

            this.indices.color,

            this.state.color,

            this.displayVariant || this.variants[0] || null

          );

        }

        if (!variant) {

          variant = findVariantAny(

            this.variants,

            [this.indices.color],

            [this.state.color],

            this.indices.color

          );

        }

      } else {

        variant = findVariant(

          this.variants,

          [this.indices.storage, this.indices.grade, this.indices.color],

          [this.state.storage, this.state.grade, this.state.color],

          this.indices.color

        );

        // Used phones: still show list price on fully sold-out combo.

        if (!variant) {

          variant = findVariantAny(

            this.variants,

            [this.indices.storage, this.indices.grade, this.indices.color],

            [this.state.storage, this.state.grade, this.state.color],

            this.indices.color

          );

        }

        if (!variant && this.indices.storage >= 0 && this.indices.grade >= 0) {

          variant = cheapestForStorageGrade(

            this.variants,

            this.indices,

            this.state.storage,

            this.state.grade

          );

        }

      }

      this.displayVariant = variant;

      if (variant && this.els.variantSelect) {

        var nextId = String(variant.id);

        // Disabled sold-out <option> cannot receive .value — enable briefly for sync.

        var opt = this.els.variantSelect.querySelector('option[value="' + nextId + '"]');

        if (opt && opt.disabled) opt.disabled = false;

        if (this.els.variantSelect.value !== nextId) {

          this.els.variantSelect.value = nextId;

          this.els.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

          if (window.jQuery) {

            window.jQuery(this.els.variantSelect).trigger('change');

          }

          if (window.history && typeof window.history.replaceState === 'function') {

            try {

              var u = new URL(window.location.href);

              u.searchParams.set('variant', nextId);

              window.history.replaceState({ path: u.toString() }, '', u.toString());

            } catch (_e) {

              /* noop */

            }

          }

        }

        this.notifyO2OVariantChange(variant);

      }

    } else {

      variant = this.getCurrentVariant();

      this.displayVariant = variant;

    }



    if (this.isUsedPhone) {

      this.syncPhoneGallery(variant);

    } else if (this.state.color) {

      this.goToColorSlide(this.state.color);

    } else {

      this.syncAccessoryGallery(variant);

    }



    if (this.els.barcodeRow && this.els.barcodeVal) {

      var nextBarcode = variant ? barcode8(variant.barcode) : '';

      if (nextBarcode) {

        this.els.barcodeVal.textContent = nextBarcode;

        this.els.barcodeRow.hidden = false;

      } else {

        this.els.barcodeRow.hidden = true;

      }

    }



    if (this.els.price) {

      this.els.price.textContent = variant

        ? money(variant.price, this.moneyFormat)

        : '-';

    }

    if (this.els.comparePrice) {

      var onSale =

        variant &&

        variant.compare_at_price &&

        variant.compare_at_price > variant.price;

      if (onSale) {

        this.els.comparePrice.textContent = money(

          variant.compare_at_price,

          this.moneyFormat

        );

        this.els.comparePrice.hidden = false;

        this.els.comparePrice.removeAttribute('aria-hidden');

      } else {

        this.els.comparePrice.hidden = true;

        this.els.comparePrice.setAttribute('aria-hidden', 'true');

        this.els.comparePrice.textContent = '';

      }

    }

    if (this.els.savings) {

      var onSaleSavings = !!(

        variant &&

        variant.compare_at_price &&

        variant.compare_at_price > variant.price

      );

      this.els.savings.hidden = !onSaleSavings;

      if (onSaleSavings) {

        var savingsCents = variant.compare_at_price - variant.price;

        var savingsPct = Math.round((savingsCents * 100) / variant.compare_at_price);

        var savingsAmountEl = this.els.savings.classList.contains('pdp-v2__savings-amount')

          ? this.els.savings

          : this.els.savings.querySelector('.pdp-v2__savings-amount');

        if (savingsAmountEl) {

          savingsAmountEl.textContent =

            (this.i18n.youSave || 'Ietaupījums') +

            ' ' +

            money(savingsCents, this.moneyFormat) +

            ' (' +

            savingsPct +

            '%)';

        }

        var savingsCompareEl = this.els.savings.querySelector('.pdp-v2__savings-compare');

        if (savingsCompareEl) {

          savingsCompareEl.textContent = money(variant.compare_at_price, this.moneyFormat);

        }

      }

    }

    if (this.els.lowStock) {

      var lowQty = variant ? variant.inventory_quantity || 0 : 0;

      var showLowStock = !!(

        variant &&

        variant.available &&

        variant.inventory_management === 'shopify' &&

        lowQty > 0 &&

        lowQty < 3

      );

      this.els.lowStock.hidden = !showLowStock;

      if (showLowStock) {

        var lowStockMsg =

          lowQty === 1

            ? this.i18n.lowStockSingular || 'Pasteidzies, palicis '

            : this.i18n.lowStockPlural || 'Pasteidzies, palikuši ';

        this.els.lowStock.textContent = lowStockMsg + lowQty;

      }

    }

    if (this.els.priceLabel) {

      this.els.priceLabel.textContent = variant &&

        variant.compare_at_price &&

        variant.compare_at_price > variant.price

        ? this.i18n.saleLabel || 'Akcija'

        : this.i18n.priceLabel || 'Cena';

    }

    if (this.els.leasing) {

      this.els.leasing.textContent = variant

        ? '€' + leasingFromPrice(variant.price) + '/' + (this.i18n.leasingMonth || 'mēn')

        : '-';

    }

    // Battery row is static (constant 84-100% range rendered in Liquid).

    var missing = this.getFirstMissingSelection();

    var canPurchase = !!(variant && variant.available && variant.price > 0);

    var showOosUi = !canPurchase && !missing;

    if (this.els.pricePanel) {

      this.els.pricePanel.hidden = showOosUi;

    }

    if (this.els.cta) {

      this.els.cta.disabled = showOosUi;

      this.els.cta.classList.toggle('pdp-v2__btn--soldout', showOosUi);

    }

    if (this.els.ctaIcon) {

      this.els.ctaIcon.hidden = showOosUi;

    }

    if (this.els.altCta) {

      this.els.altCta.hidden = !showOosUi;

    }

    if (this.els.oosNote) {

      this.els.oosNote.hidden = !showOosUi;

    }

    if (this.els.addBtn) {

      this.els.addBtn.disabled = !(variant && variant.available) || (variant != null && variant.price === 0);

    }

    if (this.els.homeDelivery) {

      var canDeliver = !!(variant && variant.available);

      this.els.homeDelivery.hidden = !canDeliver;

      this.els.homeDelivery.disabled = !canDeliver;

    }

    this.syncCtaLabel();

  };



  PdpUsedPhone.prototype.syncCtaLabel = function () {

    if (!this.els.ctaLabel) return;

    var variant = this.displayVariant || this.getCurrentVariant();

    var canPurchase = !!(variant && variant.available && variant.price > 0);

    var missing = this.getFirstMissingSelection();

    if (!canPurchase && !missing) {

      this.els.ctaLabel.textContent = this.i18n.soldOutCta || this.i18n.outOfStock || 'Izpārdots';

      return;

    }

    if (this.isUsedPhone) {

      this.els.ctaLabel.textContent = this.i18n.addToCart || 'Ielikt grozā';

      return;

    }

    // Accessory: card uses «Atlasīt opcijas»; PDP ATC matches theme add_to_cart (not phone «Pasūtīt»).

    if (missing) {

      this.els.ctaLabel.textContent = this.i18n.selectOptions || 'Atlasīt opcijas';

      return;

    }

    this.els.ctaLabel.textContent =

      this.i18n.accessoryAddToCart || this.i18n.addToCart || 'Pievienot grozam';

  };



  PdpUsedPhone.prototype.addToCartAndGoToCart = function () {

    if (this._atcInFlight) return;

    this._atcInFlight = true;

    this.applyVariant();

    var missing = this.getFirstMissingSelection();

    if (missing) {

      this._atcInFlight = false;

      this.highlightMissingSelection(missing);

      return;

    }

    var variantSelect = this.els.variantSelect;

    if (!variantSelect || !variantSelect.value) {

      this._atcInFlight = false;

      this.highlightMissingSelection(missing || 'storage');

      return;

    }

    var variant = this.getCurrentVariant();

    if (!variant || !variant.available || variant.price === 0) {

      this._atcInFlight = false;

      if (this.els.cta) {

        this.els.cta.disabled = true;

        this.els.cta.classList.add('pdp-v2__btn--soldout');

      }

      this.syncCtaLabel();

      return;

    }



    var qtyEl = document.querySelector('#quantity');

    var qty = parseInt(qtyEl && qtyEl.value, 10);

    if (!qty || qty < 1) qty = 1;



    var cartUrl =

      (window.routes && window.routes.cart_url) || '/cart';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    var cartDrawer = document.querySelector('cart-drawer');



    var bundleItems = window.AiooCompleteSet && window.AiooCompleteSet.itemsForAdd
      ? window.AiooCompleteSet.itemsForAdd(variantSelect.value, qty)
      : null;

    var formData = new FormData();

    if (bundleItems && bundleItems.length) {
      bundleItems.forEach(function (item, index) {
        formData.append('items[' + index + '][id]', String(item.id));
        formData.append('items[' + index + '][quantity]', String(item.quantity || 1));
      });
    } else {
      formData.append('id', variantSelect.value);
      formData.append('quantity', String(qty));
    }

    if (cartDrawer) {

      formData.append(

        'sections',

        cartDrawer.getSectionsToRender().map(function (s) { return s.id; })

      );

      formData.append('sections_url', window.location.pathname);

      cartDrawer.setActiveElement(document.activeElement);

    }



    var self = this;

    var navigated = false;

    var cta = this.els.cta;

    if (cta) {

      cta.disabled = true;

      cta.setAttribute('aria-busy', 'true');

    }



    var config =

      typeof fetchConfig === 'function'

        ? fetchConfig('javascript')

        : { method: 'POST', credentials: 'same-origin' };

    config.headers = config.headers || {};

    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    delete config.headers['Content-Type'];

    config.body = formData;



    fetch(addUrl, config)

      .then(function (r) {

        return r.json();

      })

      .then(function (data) {

        if (data && data.status) {

          var msg = data.description || data.message || '';

          if (/maximum quantity.*already in your cart/i.test(msg)) {

            navigated = true;

            window.location.href = cartUrl;

            return;

          }

          window.alert(msg || 'Neizdevās pievienot grozam.');

          return;

        }

        if (typeof window.clarity === 'function') {

          window.clarity('event', 'add_to_cart');

        }

        document.dispatchEvent(new CustomEvent('aioo:cart-item-added', { detail: data }));

        if (bundleItems && bundleItems.length) {

          navigated = true;

          window.location.href = cartUrl;

          return;

        }

        if (window.AIOO_openQuickAddPopup && window.AIOO_openQuickAddPopup(data)) {

          return;

        }

        if (cartDrawer) {

          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

          cartDrawer.renderContents(data);

        } else {

          navigated = true;

          window.location.href = cartUrl;

        }

      })

      .catch(function () {

        if (self.els.addBtn && !self.els.addBtn.disabled) {

          navigated = true;

          self.els.addBtn.click();

          window.setTimeout(function () {

            window.location.href = cartUrl;

          }, 600);

        } else {

          window.alert('Neizdevās pievienot grozam.');

        }

      })

      .finally(function () {

        if (navigated) return;

        self._atcInFlight = false;

        if (cta) {

          var current = self.getCurrentVariant();

          cta.disabled = !(current && current.available && current.price > 0);

          cta.removeAttribute('aria-busy');

        }

      });

  };



  function hydrateGalleryImages(scope) {

    var root = scope || document;

    var imgs = root.querySelectorAll('.pdp-v2-gallery .imgWrapper img');

    imgs.forEach(function (img) {

      var hi = img.getAttribute('data-src');

      if (!hi) return;

      if (window.lazySizes && window.lazySizes.loader) {

        try {

          window.lazySizes.loader.unveil(img);

        } catch (_e) { /* noop */ }

      }

      var src = img.currentSrc || img.src || '';

      var stuckTiny = /(?:_50x|width=50\b|\/50x)/i.test(src) || (img.naturalWidth > 0 && img.naturalWidth < 120);

      if (!img.classList.contains('lazyloaded') && (stuckTiny || src.indexOf(hi) === -1)) {

        img.src = hi;

        img.classList.add('lazyloaded');

        img.classList.remove('lazyload');

      }

    });

  }



  function initGallery() {

    var shell = document.querySelector('.pdp-v2-gallery');

    if (!shell) return;

    var counter = document.querySelector('[data-pdp-v2-gallery-counter]');

    var slider = shell.querySelector('.primgSlider');

    if (!slider || !counter) return;



    function slideCount() {

      if (shell.getAttribute('data-pdp-accessory-gallery') === 'single') return 1;

      return Array.prototype.filter.call(

        slider.querySelectorAll('.pr_photo, .pswip, .pr_photo.pswipe'),

        function (cell) { return !cell.classList.contains('pdp-gallery-off'); }

      ).length || 1;

    }



    function updateCounter(index) {

      counter.textContent = index + 1 + ' / ' + slideCount();

    }



    if (shell.getAttribute('data-pdp-accessory-gallery') === 'single') {

      counter.textContent = '1 / 1';

      shell.classList.add('pdp-v2-gallery--single');

    }



    function bindFlickity() {

      if (!window.jQuery) return false;

      var $slider = window.jQuery(slider);

      var flkty = $slider.data('flickity');

      if (!flkty) return false;

      updateCounter(flkty.selectedIndex || 0);

      hydrateGalleryImages(slider);

      if (isGalleryByColor(shell)) preloadGalleryColors(slider);

      $slider.off('change.flickity.pdpv2').on('change.flickity.pdpv2', function (_e, index) {

        updateCounter(index);

        hydrateGalleryImages(slider);

        if (isGalleryByColor(shell)) {

          syncGalleryActiveThumb(flkty, index);

        } else {

          document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumb').forEach(function (thumb, i) {

            thumb.classList.toggle('activeSlide', i === index);

          });

        }

        var instances = (window.AIOO_PDP_V2 && window.AIOO_PDP_V2._instances) || [];

        var inst = instances.filter(function (i) { return i.isUsedPhone; })[0];

        if (inst) inst.syncRepresentativeBadgeForSlideIndex(index);

      });

      return true;

    }



    hydrateGalleryImages(shell);



    var tries = 0;

    var timer = setInterval(function () {

      tries += 1;

      if (bindFlickity() || tries > 20) clearInterval(timer);

    }, 250);



    document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumbs_item').forEach(function (item) {

      item.addEventListener('click', function (e) {

        var idx = parseInt(item.getAttribute('data-slide'), 10);

        if (window.jQuery && window.jQuery(slider).data('flickity')) {

          e.preventDefault();

          window.jQuery(slider).flickity('select', idx);

        }

      });

    });



    if (isGalleryByColor(shell)) {

      // theme.js maps a thumb to a slide by its DOM position, which is wrong while the thumbs of the

      // other colours are hidden: handle the click here (capture phase) from the renumbered data-slide.

      document.querySelectorAll('.pdp-v2-gallery__thumbs .pr_thumbs_item').forEach(function (item) {

        item.addEventListener('click', function (e) {

          e.preventDefault();

          e.stopPropagation();

          var idx = parseInt(item.getAttribute('data-slide'), 10);

          if (!isNaN(idx) && window.jQuery && window.jQuery(slider).data('flickity')) {

            window.jQuery(slider).flickity('select', idx);

          }

        }, true);

      });

    }



    var prevBtn = document.querySelector('[data-pdp-v2-gallery-prev]');

    var nextBtn = document.querySelector('[data-pdp-v2-gallery-next]');

    if (prevBtn) {

      prevBtn.addEventListener('click', function () {

        if (window.jQuery && window.jQuery(slider).data('flickity')) {

          window.jQuery(slider).flickity('previous');

        }

      });

    }

    if (nextBtn) {

      nextBtn.addEventListener('click', function () {

        if (window.jQuery && window.jQuery(slider).data('flickity')) {

          window.jQuery(slider).flickity('next');

        }

      });

    }

  }



  function watchO2oStore(root) {

    var o2oRoot = root.querySelector('[data-o2o-root]');

    if (!o2oRoot) return;

    var observer = new MutationObserver(function () {

      var inst = root.getAttribute('data-pdp-v2-bound') === 'true';

      if (inst && window.AIOO_PDP_V2 && window.AIOO_PDP_V2._instances) {

        var found = window.AIOO_PDP_V2._instances.find(function (i) { return i.root === root; });

        if (found) found.syncCtaLabel();

      }

    });

    observer.observe(o2oRoot, { attributes: true, childList: true, subtree: true });

  }



  PdpUsedPhone.prototype.gradeLabel = function (grade) {

    var map = this.i18n.gradeLabels || {};

    return map[grade] || grade;

  };



  function initAll() {

    window.AIOO_PDP_V2 = window.AIOO_PDP_V2 || {};

    window.AIOO_PDP_V2._instances = [];

    document.querySelectorAll('[data-pdp-v2-root]').forEach(function (root) {

      if (root.getAttribute('data-pdp-v2-bound') === 'true') return;

      root.setAttribute('data-pdp-v2-bound', 'true');

      try {

        var inst = new PdpUsedPhone(root);

        window.AIOO_PDP_V2._instances.push(inst);

        watchO2oStore(root);

      } catch (e) {

        root.removeAttribute('data-pdp-v2-bound');

        if (window.console && console.error) console.error('PdpUsedPhone init failed', e);

      }

    });

    initGallery();

  }



  function bootPdpV2() {

    function start() {

      initAll();

    }



    function waitForColorLibrary() {

      if (window.AIOO_COLOR) {

        start();

        return;

      }

      var tries = 0;

      var timer = window.setInterval(function () {

        tries += 1;

        if (window.AIOO_COLOR || tries > 60) {

          window.clearInterval(timer);

          start();

        }

      }, 16);

    }



    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', waitForColorLibrary);

    } else {

      // This script is defer'd before aioo-color-canonical.js — wait for later defer scripts.

      window.setTimeout(waitForColorLibrary, 0);

    }

  }



  bootPdpV2();



  window.AIOO_PDP_V2 = window.AIOO_PDP_V2 || {};

  window.AIOO_PDP_V2.init = function () {

    if (window.AIOO_COLOR) {

      initAll();

      return;

    }

    window.setTimeout(function () {

      initAll();

    }, 0);

  };

})(window, document);

